import { h, Component } from 'preact';
import style from './style'
import {FAPaw, FAUser} from 'components/elements/FontAwesome'
import iconPaw from "../../../assets/icons/svg/paw.svg";

export default (props)=>{
	return (
		<div onClick={props.onSelect} class={style.select}>
			<div selected={props.selected}>
				<div class={style.icon}>
                    {props.genericPatients ?
                        <FAUser class={style.selectIcon}/>
                    :
                        <img src={iconPaw} class={style.selectIcon}/>
                    }
				</div>
				<div class={style.name}>
					{props.firstName ? props.firstName : 'none'}
					&nbsp;{props.lastName}
				</div>
			</div>
		</div>
	)
}


// WEBPACK FOOTER //
// ./components/groups/PatientSelectCard/index.js